import type { Entry, IcdRef } from '@/types/api';
import type { Code } from './dental';

/**
 * The ICD-10 (MKB-10) code a finding usually stands for, with the catalogue's
 * name. Only where one code fits; work like a filling or a root canal says
 * nothing certain about the diagnosis, so it suggests none.
 */
const BY_CODE: Partial<Record<Code, IcdRef>> = {
  caries: { code: 'K02.1', name: 'Karijes dentina zuba' },
  fracture: { code: 'S02.5', name: 'Prelom zuba' },
  periapical: { code: 'K04.5', name: 'Hronično zapaljenje pulpe vrha korena zuba' },
  devital: { code: 'K04.1', name: 'Izumiranje zubne pulpe' },
  root_remnant: { code: 'K08.3', name: 'Zaostao koren zuba' },
  missing: {
    code: 'K08.1',
    name: 'Gubitak zuba zbog akcidenta, vađenja ili bolesti periodoncijuma',
  },
  calculus: { code: 'K03.6', name: 'Naslage na zubu' },
  impacted: { code: 'K01.1', name: 'Uklešteni zubi' },
  wear: { code: 'K03.0', name: 'Trošenje zuba' },
};

/** Diagnoses the visit's findings point to and the visit does not have yet, in finding order. */
export function suggestDiagnoses(
  entries: readonly Pick<Entry, 'code' | 'status'>[],
  chosen: readonly IcdRef[]
): IcdRef[] {
  const out: IcdRef[] = [];
  for (const e of entries) {
    const ref = e.status === 'REJECTED' ? undefined : BY_CODE[e.code];
    if (!ref) continue;
    if (chosen.some((c) => c.code === ref.code) || out.some((o) => o.code === ref.code)) continue;
    out.push(ref);
  }
  return out;
}
